'use client';

import { IStoreInfoData } from '@/types/general';
import { createContext, useContext } from 'react';

type StoreContextType = {
  storeSetting?: IStoreInfoData;
};

export const StoreContext = createContext<StoreContextType | undefined>(undefined);

export function StoreProvider({
  value,
  children,
}: {
  value: StoreContextType;
  children: React.ReactNode;
}) {
  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}

export function useStoreSetting() {
  const ctx = useContext(StoreContext);
  if (!ctx) {
    throw new Error('useStoreSetting must be used within a StoreProvider');
  }
  return ctx;
}
